import { useMemo } from 'react';
import { FaStar, FaStarHalfAlt } from 'react-icons/fa';

import type { ComponentsHero } from 'queries/graphql';

import { buildCssVar } from 'utils/style-override';

import styles from './styles.module.scss';

type RatingStarsStyle = Omit<ComponentsHero['style'], 'createdAt' | 'id' | 'updatedAt'>;

type RatingStarsProps = Pick<ComponentsHero, 'rating'> & {
  style?: RatingStarsStyle;
  className?: string;
};

export default function RatingStars({ rating, style, className }: RatingStarsProps) {
  const parsedRating = rating || 0;
  const { starColor, starEmptyColor } = style || {};

  const { fullStars, emptyStars, useHalf } = useMemo(() => {
    const result = {
      fullStars: Math.floor(parsedRating),
      emptyStars: 5 - Math.ceil(parsedRating),
      useHalf: false,
    };

    const decimal = parsedRating - result.fullStars;

    if (decimal > 0.5) {
      // Use full star if > 0.5
      result.fullStars += 1;
    } else if (decimal > 0) {
      result.useHalf = true;
    }

    return result;
  }, [parsedRating]);

  return (
    <div className={`root ${className}`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--star-color', starColor, 'var(--default-star-color)')}
          ${buildCssVar('--star-empty-color', starEmptyColor, 'var(--default-star-empty-color)')}
        }
      `}</style>

      {[...Array(fullStars)].map((item, index) => {
        return <FaStar key={index} className={styles.yellow_star} />;
      })}
      {useHalf && <FaStarHalfAlt className={styles.yellow_star} />}
      {[...Array(emptyStars)].map((item, index) => {
        return <FaStar className={styles.grey_star} key={index} />;
      })}
    </div>
  );
}
